import { Navigate } from 'react-router-dom'
import { SUPPORTED_LANGUAGES } from '../lib/constants.js'

export function LanguageRedirect() {
  const supported = SUPPORTED_LANGUAGES as readonly string[]
  // Prefer the previously persisted choice (set by LanguageRouter) so a
  // returning visitor doesn't get bounced back to their browser language.
  let lang: string | null = null
  try {
    const stored = localStorage.getItem('acp-lang')
    if (stored && supported.includes(stored)) lang = stored
  } catch { /* storage unavailable */ }
  if (!lang) {
    const prefix = navigator.language?.split('-')[0]
    lang = prefix && supported.includes(prefix) ? prefix : 'en'
  }
  return <Navigate to={`/${lang}/`} replace />
}
